<template>
    <div class="spelling-game">
        <div class="game-header">
            <h1 class="text-2xl md:text-3xl font-bold mb-2">单词拼写游戏</h1>
            <p class="text-gray-600">填写缺失的字母完成单词</p>
        </div>

        <div>
            <el-row>
                <el-col :span="6">
                    <div class="word-title">得分</div>
                    <div class="word-title"><span class="game-info-span">{{ getScore() }}</span></div>
                </el-col>
                <el-col :span="12">
                    <div class="word-title">难易度<span class="game-info-span"></span></div>
                    <div class="word-title"><el-rate v-model="currentGame.difficulty" disabled :max="3"
                            text-color="#ff9900">
                        </el-rate></div>
                </el-col>
                <el-col :span="6">
                    <div class="word-title">剩余时间</div>
                    <div class="word-title"><span class="game-info-span">{{ time }}</span></div>
                </el-col>
            </el-row>
        </div>
        <!-- 提示信息 -->
        <div class="hint-box mb-6 p-3 bg-blue-50 rounded-lg">
            <p><span>汉语释义： "{{ currentGame.cnWord }}"</span><i @click="playAudio()"
                    :class="['word-play', iconPlay]"></i></p>
        </div>
        <!-- 单词显示与输入区域 -->
        <div class="word-container mb-8">
            <div v-for="(item, index) in wordDisplay" :key="index" class="word-item">
                <!-- 如果是输入框 -->
                <input v-if="item.isInput" type="text" v-model="item.value" maxlength="1" class="letter-input"
                    :id="'uinput' + index" :class="{
                        'correct': checked && item.value === targetWord[index],
                        'incorrect': checked && item.value !== targetWord[index] && item.value
                    }" @input="handleInput(item, index)" @focus="blankInput(item)" />
                <!-- 如果是固定字母 -->
                <span v-else class="fixed-letter">{{ item.value }}</span>
            </div>
        </div>
        <!-- <el-row>
            <div class="sound-uppercase">
                <el-switch v-model="showUppercase" @change="upperChange" active-text="A" inactive-text="a">
                </el-switch>
            </div>
        </el-row> -->
        <!-- 提示信息 -->
        <div v-if="showHint" class="hint-box mb-6 p-3 bg-amber-50 rounded-lg">
            <p class="text-amber-700"><i class="fa fa-lightbulb-o mr-1"></i> 提示: {{ currentGame.hintText }}</p>
        </div>

        <!-- 操作按钮 -->
        <div class="controls">
            <el-button type="success" icon="el-icon-document-checked" size="middle" @click="checkAnswer"
                :disabled="!allInputsFilled">检查答案
            </el-button>
            <el-button v-if="time === 0 && limitCount > 0 && hasNextWord" type="primary" icon="el-icon-arrow-down"
                @click="nextGame" size="middle">下一局
            </el-button>
            <el-button v-if="time === 0 && limitCount > 0 && hasNextWord" type="primary" icon="el-icon-refresh"
                @click="resetAnswer" size="middle">重填</el-button>
            <el-button v-else type="warning" size="middle" @click="toggleHint" icon="el-icon-warning">{{ showHint ?
                '隐藏提示' :
                '显示提示' }}
            </el-button>
            <el-button v-if="limitCount === 0 || (time === 0 && !hasNextWord)" type="primary" @click="reloadGame()"
                size="small">再开一局</el-button>
        </div>

        <!-- 结果提示 -->
        <div v-if="checked" class="result-message" :class="isCorrect ? 'success' : 'error'">
            <p v-if="isCorrect">
                <i class="fa fa-check-circle"></i> 太棒了，完全正确！
            </p>
            <p v-else>
                <i class="fa fa-times-circle"></i> 答案错误！
            </p>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api'
import { Howl } from 'howler'
export default {
    name: 'PartialWordSpelling',
    props: {
        games: {
            type: Array,
            default: () => ([])
        }
    },
    data () {
        return {
            // 当前目标单词
            targetWord: '',
            // 用于显示的单词结构（包含固定字母和输入框）
            wordDisplay: [],
            // 统计信息
            completedCount: 0,
            successCount: 0,
            showUppercase: true,
            iconPlay: 'el-icon-video-play',
            checked: false,
            showHint: false,
            myAudio: null,
            isCorrect: false,
            limitCount: 10, // 限制游戏次数
            time: 20,
            currentGame: {
                id: 0,
                difficulty: 3,
                hintText: ''
            }
        }
    },
    computed: {
        // 检查所有输入框是否已填写
        allInputsFilled () {
            return this.wordDisplay.every(item => {
                return !item.isInput || (item.isInput && item.value)
            })
        },
        // 检查是否还有下一个单词
        hasNextWord () {
            const nextIndex = this.currentGame.index + 1
            return nextIndex < this.games.length
        }
    },
    created () {
        this.targetWord = this.games.length > 0 ? this.games[0].word.toUpperCase() : 'MOBILE'
        this.currentGame = this.games.length > 0 ? Object.assign({}, this.games[0]) : { word: 'MOBILE', audioUrlId: 1 }
        this.loadSound()
    },
    mounted () {
        this.startNewWord()
    },
    methods: {
        timer () {
            if (this.time > 0) {
                this.time--
                setTimeout(this.timer, 1000)
            }
        },
        getTime () {
            if (this.currentGame.difficulty === 1) {
                this.time = 30
            } else if (this.currentGame.difficulty === 3) {
                this.time = 20
            } else {
                this.time = 25
            }
            return this.time
        },
        reloadGame () {
            this.$confirm('已经完成，继续重做?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
                center: true
            }).then(() => {
                this.$emit('load-game') // 通知父组件重新加载数据
            })
        },
        getScore () {
            return this.successCount * 10
        },
        playResultAudio (isSuccess) {
            this.myAudio = null
            let audioData = isSuccess ? this.successAudio : this.failAudio
            if (audioData) {
                var blobUrl = this.base64ToBlobUrl(audioData)

                this.myAudio = new Howl({
                    src: [blobUrl],
                    html5: true, // 强制使用HTML5 Audio
                    onend: function () {
                        this.iconPlay = 'el-icon-video-play'
                        // console.log('Finished!')
                    }
                })
                this.myAudio.play()
            }
        },
        // 将Base64转为Blob URL
        base64ToBlobUrl (base64) {
            const byteString = atob(base64)
            const ab = new ArrayBuffer(byteString.length)
            const ia = new Uint8Array(ab)

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }

            const blob = new Blob([ab], { type: 'audio/mpeg' })
            return URL.createObjectURL(blob) // 返回Blob URL
        },
        loadSound () {
            this.$axios.get(api.getSuccessMp3)
                .then(res => {
                    this.successAudio = res.data.result.base64Data
                })
            this.$axios.get(api.getFailedMp3)
                .then(res => {
                    this.failAudio = res.data.result.base64Data
                })
        },
        // 开始一个新单词
        startNewWord () {
            // 随机选择一个单词
            // 根据难度确定要隐藏的字母数量
            // 重置状态
            this.Checked = false
            this.showHint = false
            this.time = this.getTime()

            // console.log('当前单词：' + this.targetWord + ', 难度：' + this.currentGame.difficulty)
            let blankCount
            switch (this.currentGame.difficulty) {
                case 1:
                    blankCount = Math.min(3, Math.max(2, Math.floor(this.targetWord.length * 0.3)))
                    break
                case 3:
                    blankCount = Math.min(this.targetWord.length - 2, Math.floor(this.targetWord.length * 0.6))
                    break
                default: // medium
                    blankCount = Math.min(5, Math.max(4, Math.floor(this.targetWord.length * 0.4)))
            }

            // 生成要隐藏的位置
            const blankPositions = this.getRandomPositions(this.targetWord.length, blankCount)

            // 构建显示用的单词结构
            this.wordDisplay = this.targetWord.split('').map((letter, index) => {
                const isInput = blankPositions.includes(index)
                return {
                    value: isInput ? '' : letter,
                    isInput: isInput,
                    hasValue: false
                }
            })
            // console.log(this.wordDisplay)
            // 生成提示
            this.generateHint(blankPositions)
            this.timer()
            // 聚焦第一个输入框
            this.setFirstFocus()
        },

        // 获取随机位置
        getRandomPositions (total, count) {
            const positions = []
            while (positions.length < count) {
                const pos = Math.floor(Math.random() * total)
                if (!positions.includes(pos) && this.targetWord.split('')[pos].trim() !== '') {
                    positions.push(pos)
                }
            }
            return positions
        },

        // 处理输入
        handleInput (item, index) {
            // 确保输入为大写字母
            if (item.value && item.value.length > 0) {
                item.value = item.value.toUpperCase()
                item.hasValue = true
            }
            // 自动聚焦下一个输入框
            for (let i = index + 1; i < this.wordDisplay.length; i++) {
                if (this.wordDisplay[i].isInput) {
                    var nextInputElem = document.getElementById('uinput' + i)
                    if (nextInputElem) {
                        nextInputElem.focus()
                    }
                    break
                }
            }
        },
        blankInput (item) {
            item.value = ''
            item.hasValue = false
        },
        resetAnswer () {
            this.wordDisplay.forEach(item => {
                if (item.isInput) {
                    item.value = ''
                    item.hasValue = false
                }
            })
            this.checked = false
            // 聚焦第一个输入框
            this.setFirstFocus()
        },
        setFirstFocus () {
            this.$nextTick(() => {
                var first = document.getElementById('uinput0')
                if (first) {
                    first.focus()
                }
            })
        },
        // 检查答案
        checkAnswer () {
            this.checked = true
            this.time = 0 // 停止计时
            // 检查每个输入是否正确
            const userAnswer = this.wordDisplay.reduce((acc, s) => acc + (s.value || ''), '').replace(/\s+/g, '').toUpperCase()
            const expected = (this.targetWord || '').toString().replace(/\s+/g, '').toUpperCase()
            // console.log('用户答案：' + userAnswer + ', 期望答案：' + expected)
            // 比较是否与目标单词一致
            var allCorrect = userAnswer === expected
            this.isCorrect = allCorrect

            // 更新统计信息
            this.completedCount++
            if (allCorrect) {
                this.successCount++
            }
            this.playResultAudio(allCorrect)
        },

        // 重置游戏（新单词）
        nextGame () {
            this.limitCount--
            if (this.limitCount <= 0) {
                this.$emit('save-answer', this.getScore())// 通知父组件重新加载数据// 自动保存答案
                return
            }
            var index = this.currentGame.index + 1
            // console.log('下一局索引：', index)
            this.currentGame = Object.assign({}, this.games[index])
            // console.log('下一局索引：', this.currentGame)
            this.targetWord = this.currentGame.word.toUpperCase()
            // console.log('this.targetWord：', this.targetWord)
            this.startNewWord()
        },

        // 生成提示
        generateHint (blankPositions) {
            // 提示：显示一个正确字母的位置和值
            if (blankPositions.length > 0) {
                const hintPos = blankPositions[Math.floor(Math.random() * blankPositions.length)]
                this.currentGame.hintText = `第 ${hintPos + 1} 个字母是: ${this.targetWord[hintPos]}`
            } else {
                this.currentGame.hintText = '这个单词很简单！'
            }
        },
        playAudio () {
            this.myAudio = null
            var wordId = this.currentGame.id
            // console.log('播放音频，ID：', this.currentGame)
            this.$axios.post(api.getMp3, { id: wordId })
                .then(res => {
                    var blobUrl = this.base64ToBlobUrl(res.data.result.base64Data)
                    this.myAudio = new Howl({
                        src: [blobUrl],
                        html5: true, // 强制使用HTML5 Audio
                        onend: function () {
                            this.iconPlay = 'el-icon-video-play'
                            // console.log('Finished!')
                        }
                    })
                    this.myAudio.play()
                }).catch(err => {
                    this.iconPlay = 'el-icon-video-play'
                    console.log('Error fetching audio:', err)
                })
        },
        // 切换提示显示
        toggleHint () {
            this.showHint = !this.showHint
        }
    },
    watch: {
        games: {
            immediate: true,
            handler (newGames) {
                if (Array.isArray(newGames) && newGames.length > 0) {
                    // 复制一份，避免直接修改父组件数据
                    this.currentGame = Object.assign({}, newGames[0])
                    if (this.currentGame.index === undefined) {
                        this.currentGame.index = 0
                    }
                    this.limitCount = newGames.length
                    this.targetWord = (this.currentGame.word || '').toString().toUpperCase()
                    this.startNewWord()
                }
            }
        }
    }
}
</script>

<style scoped>
.spelling-game {
    max-width: 800px;
    margin: 2rem auto;
    padding: 2rem;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.game-header {
    text-align: center;
    margin-bottom: 1.5rem;
}

.difficulty-selector {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.difficulty-label {
    color: #64748b;
    font-weight: 500;
}

.difficulty-select {
    padding: 0.4rem 0.8rem;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    background-color: white;
    font-size: 14px;
    color: #334155;
}

.word-container {
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 2rem;
}

.word-item {
    display: flex;
    align-items: center;
    justify-content: center;
}

.letter-input {
    width: 50px;
    height: 50px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    border: 2px solid #3b82f6;
    border-radius: 8px;
    transition: all 0.2s ease;
    text-transform: uppercase;
}

.letter-input:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.letter-input.correct {
    border-color: #10b981;
    background-color: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.letter-input.incorrect {
    border-color: #ef4444;
    background-color: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

.fixed-letter {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    color: #334155;
    background-color: #f1f5f9;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
}

.word-play {
    margin-left: 10px;
    color: #3bf6a2;
    cursor: pointer;
    font-size: 25px;
    border-radius: 5px;
}

.hint-box {
    text-align: center;
    font-weight: 500;
}

.controls {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 1.5rem;
}

.check-btn,
.reset-btn,
.hint-btn {
    padding: 0.6rem 1.2rem;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
}

.check-btn {
    background-color: #10b981;
    color: white;
}

.check-btn:disabled {
    background-color: #a7f3d0;
    cursor: not-allowed;
}

.check-btn:not(:disabled):hover {
    background-color: #059669;
    transform: translateY(-2px);
}

.reset-btn {
    background-color: #6b7280;
    color: white;
}

.reset-btn:hover {
    background-color: #4b5563;
    transform: translateY(-2px);
}

.hint-btn {
    background-color: #f59e0b;
    color: white;
}

.hint-btn:hover {
    background-color: #d97706;
    transform: translateY(-2px);
}

.result-message {
    margin-top: 1rem;
    padding: 1rem;
    border-radius: 8px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    transition: all 0.3s ease;
}

.result-message.success {
    background-color: rgba(16, 185, 129, 0.1);
    color: #059669;
}

.result-message.error {
    background-color: rgba(239, 68, 68, 0.1);
    color: #dc2626;
}

.stats {
    text-align: center;
    color: #64748b;
    font-size: 14px;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px dashed #e2e8f0;
}

.word-title {
    text-align: center;
    font-size: 15px;
    margin: 0px;
    padding: 5px 0px;
}

.game-info-span {
    font-size: 18px;
    font-weight: bold;
    margin-left: 8px;
    text-align: center;
    color: #3b82f6;
}

/* 响应式设计 */
@media (max-width: 600px) {
    .spelling-game {
        padding: 1rem;
        margin: 1rem;
    }

    .letter-input,
    .fixed-letter {
        width: 40px;
        height: 40px;
        font-size: 20px;
    }

    .controls {
        gap: 0.8rem;
    }

    .check-btn,
    .reset-btn,
    .hint-btn {
        padding: 0.5rem 1rem;
        font-size: 14px;
    }

    .sound-uppercase {
        text-align: center;
        margin: 10px auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game/wordinputtemplete.vue